import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTaskEventTypesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.TaskEventTypeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.TaskEventTypeDocumentSortInput> | Types.TaskEventTypeDocumentSortInput>;
}>;


export type GetTaskEventTypesQuery = { __typename?: 'Query', taskEventTypes?: { __typename?: 'TaskEventTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskEventTypeDocument', id: string, taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type TaskEventTypeSummaryFragment = { __typename?: 'TaskEventTypeDocument', id: string, taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string };

export const TaskEventTypeSummaryFragmentDoc = new TypedDocumentString(`
    fragment TaskEventTypeSummary on TaskEventTypeDocument {
  id
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}
    `, {"fragmentName":"TaskEventTypeSummary"});
export const GetTaskEventTypesDocument = new TypedDocumentString(`
    query GetTaskEventTypes($first: Int, $after: String, $last: Int, $before: String, $where: TaskEventTypeDocumentFilterInput, $order: [TaskEventTypeDocumentSortInput!]) {
  taskEventTypes(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...TaskEventTypeSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment TaskEventTypeSummary on TaskEventTypeDocument {
  id
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTaskEventTypes: build.query<GetTaskEventTypesQuery, GetTaskEventTypesQueryVariables | void>({
      query: (variables) => ({ document: GetTaskEventTypesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTaskEventTypesQuery, useLazyGetTaskEventTypesQuery } = injectedRtkApi;
